import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Row, Col, Input, Divider } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import Editor from '../components/Editor';

function NoteTemplateAdd() {
	const navigate = useNavigate();
	const { editNoteTemplateId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const get = () => {
		if (!editNoteTemplateId) {
			return;
		}
		axios
			.get(`/note-template`, { params: { _id: editNoteTemplateId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					if (data?.templateRichText?.delta) {
						data.templateRichText.delta = JSON.parse(data.templateRichText.delta);
					}
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editNoteTemplateId) {
					values._id = editNoteTemplateId;
				}
				if (values?.templateRichText?.delta) {
					values.templateRichText.delta = JSON.stringify(values.templateRichText.delta);
				}
				axios({
					method: editNoteTemplateId ? 'put' : 'post',
					url: '/note-template',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/note-templates');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						link: '/note-templates',
						label: 'Note Templates',
					},
					{
						label: editNoteTemplateId ? 'Edit' : 'Add',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editNoteTemplateId ? 'Edit Note Template' : 'Add Note Template'}</div>
						<div className='page-title-more'>
							<Link to='/note-templates'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Row gutter={[16, 0]}>
								<Col sm={24} md={24}>
									<Form.Item label='Template Name' name='templateName'>
										<Input maxLength={500} style={{ width: '100%' }} />
									</Form.Item>
								</Col>
								<Col sm={24} md={24}>
									<Form.Item label='Template Details' name='templateText'>
										<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} />
									</Form.Item>
								</Col>
								<Col sm={24} md={24}>
									<Divider>OR</Divider>
								</Col>
								<Col sm={24} md={24}>
									<Form.Item label='Template RichText' name='templateRichText'>
										<Editor Form={Form} />
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default NoteTemplateAdd;
